import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { AiOutlinePause } from "react-icons/ai";
import { AiOutlinePlayCircle } from "react-icons/ai";

let OnHoldAPEButton = (props) => {
    return (
        <Tooltip title="Suspender APE">
            <IconButton
                aria-label="Add"
                disabled={props.disabled}
                onClick={() => props.onClick()}
            >
                {props.suspendida ? <AiOutlinePlayCircle /> : <AiOutlinePause />}
            </IconButton>
        </Tooltip>
    );
}

export default OnHoldAPEButton;

  

